

























































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import FileUpload from "@/components/common/Inputs/FileUpload.vue";
import MultiFileUpload from "@/components/common/Inputs/MultipleFileUpload.vue";
import FileDownload from "@/components/common/fileDownload/fileDownload.vue";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";

@Component({
  components: {
    FileUpload,
    MultiFileUpload,
    FileDownload,
  },
})
export default class SampleDocument extends Vue {
  @Prop() docTags: any;
  @Prop() financialReport: FinancialReportData;
  @Prop() formOptions: any;
  @Prop() auditDocs: Array<any>;
  @Prop() readOnly: boolean;

  finSampleDocsKey: number = 1;
  showHistory: boolean = false;

  get requestedSamples() {
    let finReportId = this.financialReport.selectedReport.FinancialReportId;
    let docs = this.auditDocs.filter(
      (x) => x.transactionId == finReportId && x.isOpen == 1
    );

    if (docs && docs[0]) {
      return docs[0];
    } else return {};
  }

  get sampleHistory() {
    let finReportId = this.financialReport.selectedReport.FinancialReportId;
    let docs = this.auditDocs.filter(
      (x) => x.transactionId == finReportId && x.isOpen == 0
    );

    return docs || [{}];
  }

  onUploadAuditFile(e, doc) {
    let self = this;
    const { name, type, size } = e;
    this.$services.document
      .uploadDocument(
        e,
        {
          options: {
            docTag: doc.docType,
            menu: _app.menu.finReport,
          },
        },
        this.financialReport.selectedReport.FinancialReportId,
        this.$vuetify.lang.current
      )
      .then((data) => {
        Object.assign(doc.documents, data, { name, type, size });

        this.$services.monitor
          .saveRequestedDoc(self.requestedSamples)
          .then((data: any) => {
            if (data) {
              self.requestedSamples.version = data.version;

              // Set invoice details
              data.records.map((x) => {
                let item = self.requestedSamples.records.find(
                  (x) => x.itemId == x.itemId
                );

                if (item) {
                  x.invoiceNo = item.invoiceNo;
                  x.budgetLine = item.budgetLine;
                  x.budgetCategory = item.budgetCategory;
                  x.description = item.description;
                }
              });

              self.requestedSamples.records = data.records;
              // Display success message
            } else {
              // Display error message
            }
          });
      });

    this.$emit("input", true);
  }

  onRemoveAuditFile(index, doc) {
    let self = this;

    if (doc.documentId) {
      this.$services.document.removeDocument(doc).then((data) => {
        doc.description = null;
        doc.documentId = 0;
        doc.name = null;
        doc.size = 0;
        doc.type = null;
        doc.uploadedFileName = null;

        this.$services.monitor
          .saveRequestedDoc(this.requestedSamples)
          .then((data: any) => {
            if (data) {
              this.requestedSamples.version = data.version;

              // Set invoice details
              data.records.map((x) => {
                let item = self.requestedSamples.records.find(
                  (x) => x.itemId == x.itemId
                );

                if (item) {
                  x.invoiceNo = item.invoiceNo;
                  x.budgetLine = item.budgetLine;
                  x.budgetCategory = item.budgetCategory;
                  x.description = item.description;
                }
              });

              this.requestedSamples.records = data.records;
              // Display success message
            } else {
              // Display error message
            }
          });
      });
    } else {
    }
    this.$emit("input", true);
  }
}
